import AMENITIES_LOCALE from './AmenitiesLocale';
import PROPERTIES_LOCALE from './PropertyTypesLocale';

const CATEGORY = {
  HOTEL: 'hotel',
  FLIGHT: 'flight',
};

const EVENT_TYPE = {
  SORT: 'sort',
  FILTER: 'filter',
};

const SORT_TYPE = {
  RECOMMENDED: 'recommended',
  PRICE_LOW_TO_HIGH: 'priceLowToHigh',
  PRICE_HIGH_TO_LOW: 'priceHighToLow',
  USER_RATING: 'userRating',
};

const getSortByOptions = translate => [
  {
    id: SORT_TYPE.RECOMMENDED,
    text: translate('sortAndFilter.type.recommended'),
  },
  {
    id: SORT_TYPE.PRICE_LOW_TO_HIGH,
    text: translate('sortAndFilter.type.priceLowToHigh'),
  },
  {
    id: SORT_TYPE.PRICE_HIGH_TO_LOW,
    text: translate('sortAndFilter.type.priceHighToLow'),
  },
  {
    id: SORT_TYPE.USER_RATING,
    text: translate('sortAndFilter.type.userRating'),
  },
];

const getSortByOptionsNew = translate => [
  {
    id: SORT_TYPE.RECOMMENDED,
    text: translate('sortAndFilter.type.recommended'),
    subText: translate('sortAndFilter.subTextRecommended'),
  },
  {
    id: SORT_TYPE.PRICE_LOW_TO_HIGH,
    text: translate('sortAndFilter.type.lowestPrice'),
  },
  {
    id: SORT_TYPE.PRICE_HIGH_TO_LOW,
    text: translate('sortAndFilter.type.highestPrice'),
  },
  {
    id: SORT_TYPE.USER_RATING,
    text: translate('sortAndFilter.type.topGuestRating'),
  },
];

const AMENTITIES_FILTER_TYPE = {
  FREE_WIFI: 1,
  POOL: 2,
  GYM: 3,
  SPA: 4,
  PRIVATE_BEACH: 5,
  AIRPORT_TRANSFER: 6,
  SMOKING_AREA: 7,
  SMOKE_FREE_PROPERTY: 8,
  RESTAURANT: 9,
  POOLSIDE_BAR: 10,
  CAFE: 11,
  BAR: 12,
  TENIS_COURT: 13,
  SAUNA: 14,
  NIGHT_CLUB: 15,
};

const getAmentitiesLocalised = locale => {
  const amenitiesLocale = AMENITIES_LOCALE[locale];
  return [
    {
      text: amenitiesLocale.filter_1,
      value: AMENTITIES_FILTER_TYPE.FREE_WIFI,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_2,
      value: AMENTITIES_FILTER_TYPE.POOL,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_3,
      value: AMENTITIES_FILTER_TYPE.GYM,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_4,
      value: AMENTITIES_FILTER_TYPE.SPA,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_5,
      value: AMENTITIES_FILTER_TYPE.PRIVATE_BEACH,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_6,
      value: AMENTITIES_FILTER_TYPE.AIRPORT_TRANSFER,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_7,
      value: AMENTITIES_FILTER_TYPE.SMOKING_AREA,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_8,
      value: AMENTITIES_FILTER_TYPE.SMOKE_FREE_PROPERTY,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_9,
      value: AMENTITIES_FILTER_TYPE.RESTAURANT,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_10,
      value: AMENTITIES_FILTER_TYPE.POOLSIDE_BAR,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_11,
      value: AMENTITIES_FILTER_TYPE.CAFE,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_12,
      value: AMENTITIES_FILTER_TYPE.BAR,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_13,
      value: AMENTITIES_FILTER_TYPE.TENIS_COURT,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_14,
      value: AMENTITIES_FILTER_TYPE.SAUNA,
      isChecked: false,
    },
    {
      text: amenitiesLocale.filter_15,
      value: AMENTITIES_FILTER_TYPE.NIGHT_CLUB,
      isChecked: false,
    },
  ];
};

const getPropertyTypesLocalised = locale => {
  const propertiesLocale = PROPERTIES_LOCALE[locale];
  return propertiesLocale;
};

const getAmentitiesList = translate => [
  {
    text: translate('amenityFilter.filter_1'),
    value: AMENTITIES_FILTER_TYPE.FREE_WIFI,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_2'),
    value: AMENTITIES_FILTER_TYPE.POOL,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_3'),
    value: AMENTITIES_FILTER_TYPE.GYM,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_4'),
    value: AMENTITIES_FILTER_TYPE.SPA,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_5'),
    value: AMENTITIES_FILTER_TYPE.PRIVATE_BEACH,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_6'),
    value: AMENTITIES_FILTER_TYPE.AIRPORT_TRANSFER,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_7'),
    value: AMENTITIES_FILTER_TYPE.SMOKING_AREA,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_8'),
    value: AMENTITIES_FILTER_TYPE.SMOKE_FREE_PROPERTY,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_9'),
    value: AMENTITIES_FILTER_TYPE.RESTAURANT,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_10'),
    value: AMENTITIES_FILTER_TYPE.POOLSIDE_BAR,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_11'),
    value: AMENTITIES_FILTER_TYPE.CAFE,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_12'),
    value: AMENTITIES_FILTER_TYPE.BAR,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_13'),
    value: AMENTITIES_FILTER_TYPE.TENIS_COURT,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_14'),
    value: AMENTITIES_FILTER_TYPE.SAUNA,
    isChecked: false,
  },
  {
    text: translate('amenityFilter.filter_15'),
    value: AMENTITIES_FILTER_TYPE.NIGHT_CLUB,
    isChecked: false,
  },
];

const GuestRatingOptions = [
  { text: '3+', id: '3' },
  { text: '3.5+', id: '3.5' },
  { text: '4+', id: '4' },
  { text: '4.5+', id: '4.5' },
];

const getHotelClassOptions = translate => {
  const starTranslation = translate('sortAndFilter.star');
  return [
    { id: 'five', value: `5 ${starTranslation}` },
    { id: 'four', value: `4 ${starTranslation}` },
    { id: 'three', value: `3 ${starTranslation}` },
    { id: 'two', value: `2 ${starTranslation}` },
    { id: 'one', value: `1 ${starTranslation}` },
  ];
};

const getPaymentCancellationOptions = (
  translate,
  isSnap = false,
  enablePayNowFilter,
  enablePayLater = true
) => {
  const freeCancellation = translate('roomCard.optional.freeCancellation');
  const freeHotelCancellation = translate(
    'roomCard.optional.freeHotelCancellation'
  );
  const payLater = translate('roomCard.payLater');
  const payAtHotel = translate('tags.pay_at_hotel');
  const payNow = translate('sortAndFilter.pay_now');

  if (isSnap) {
    return [{ id: 'free_cancellation', value: freeHotelCancellation }];
  }
  const options = [
    { id: 'free_cancellation', value: freeCancellation },
    { id: 'bnpl', value: payLater },
    { id: 'pay_at_hotel', value: payAtHotel },
  ];
  if (!enablePayLater) {
    options.splice(1, 1);
  }
  if (enablePayNowFilter) {
    options.splice(1, 0, { id: 'pay_now', value: payNow });
  }
  return options;
};

export {
  CATEGORY,
  EVENT_TYPE,
  SORT_TYPE,
  getSortByOptions,
  GuestRatingOptions,
  getHotelClassOptions,
  AMENTITIES_FILTER_TYPE,
  getAmentitiesList,
  getPropertyTypesLocalised,
  getAmentitiesLocalised,
  getPaymentCancellationOptions,
  getSortByOptionsNew,
};
